/**
 * Check months
 * @param element
 */
window.checkMonths = function(element) {
  const verbrauchMonthFrom = $('#verbrauchMonthFrom option');
  const verbrauchMonthTo = $('#verbrauchMonthTo option');

  if ($(element).is('#verbrauchMonthFrom')) {
    verbrauchMonthTo.removeAttr('disabled');
    verbrauchMonthTo.each(function() {
      if ($(this).val() <= $(element).val()) {
        $(this).attr('disabled', 'disabled');
      }
    });
  } else {
    verbrauchMonthFrom.removeAttr('disabled');
    verbrauchMonthFrom.each(function() {
      if ($(this).val() >= $(element).val()) {
        $(this).attr('disabled', 'disabled');
      }
    });
  }
};

/**
 * Send form: Monatlicher Verbrauch
 * @param element
 */
window.sendFormMonatlicherVerbrauch = function(element) {
  const year = $(element).closest('form').find('#verbrauchYear');
  year.closest('div.form-field').removeClass('form-field--error');

  const monthFrom = $(element).closest('form').find('#verbrauchMonthFrom');
  monthFrom.closest('div.form-field').removeClass('form-field--error');

  const monthTo = $(element).closest('form').find('#verbrauchMonthTo');
  monthTo.closest('div.form-field').removeClass('form-field--error');

  $(element).closest('form').find('.title-betriebsleiter').removeClass('text-red');

  let checked = false;
  $(element).closest('form').find('#verbrauch-liste input.betriebsleiter-row').each(function(i, v) {
    if ($(v).is(':checked')) {
      checked = true;
    }
  });

  if (monthFrom.val() === '' || monthTo.val() === '' || year.val() === '' || checked === false) {
    if (year.val() === '') {
      $(element).closest('form').find('#verbrauchYear').closest('div.form-field').addClass('form-field--error');
    }
    if (monthFrom.val() === '') {
      $(element).closest('form').find('#verbrauchMonthFrom').closest('div.form-field').addClass('form-field--error');
    }
    if (monthTo.val() === '') {
      $(element).closest('form').find('#verbrauchMonthTo').closest('div.form-field').addClass('form-field--error');
    }
    if (checked === false) {
      $(element).closest('form').find('.title-betriebsleiter').addClass('text-red');
    }
  } else {
    $(element).closest('form').submit();
    setTimeout(function() {
      ajaxDialog('close');
    }, 100);
  }
};

/**
 * Send form: Lagerbewegungsliste
 * @param element
 */
window.sendFormLagerbewegungsliste = function(element) {
  const dateFrom = $(element).closest('form').find('#verbrauchDateFrom');
  dateFrom.closest('div.form-field').removeClass('form-field--error');

  const dateTo = $(element).closest('form').find('#verbrauchDateTo');
  dateTo.closest('div.form-field').removeClass('form-field--error');

  $(element).closest('form').find('.title-betriebsleiter').removeClass('text-red');

  let checked = false;
  $(element).closest('form').find('#verbrauch-liste input.betriebsleiter-row').each(function(i, v) {
    if ($(v).is(':checked')) {
      checked = true;
    }
  });

  const parsedDateVon = new Date(dateFrom.val());
  const parsedDateBis = new Date(dateTo.val());

  if (dateFrom.val() === '' || dateTo.val() === '' || checked === false) {
    if (dateFrom.val() === '') {
      $(element).closest('form').find('#verbrauchDateFrom').closest('div.form-field').addClass('form-field--error');
    }
    if (dateTo.val() === '') {
      $(element).closest('form').find('#verbrauchDateTo').closest('div.form-field').addClass('form-field--error');
    }
    if (checked === false) {
      $(element).closest('form').find('.title-betriebsleiter').addClass('text-red');
    }
  } else if (parsedDateVon.getTime() > parsedDateBis.getTime()) {
    $(element).closest('form').find('#verbrauchDateFrom').closest('div.form-field').addClass('form-field--error');
    $(element).closest('form').find('#verbrauchDateTo').closest('div.form-field').addClass('form-field--error');
  } else if (parsedDateVon.getFullYear() !== parsedDateBis.getFullYear()) {
    $(element).closest('form').find('#verbrauchDateFrom').closest('div.form-field').addClass('form-field--error');
    $(element).closest('form').find('#verbrauchDateTo').closest('div.form-field').addClass('form-field--error');
  } else {
    $(element).closest('form').submit();
    setTimeout(function() {
      ajaxDialog('close');
    }, 100);
  }
};

/**
 * sendForm
 * @param element
 */
window.sendFormLagerbestaende = function(element) {
  $(element).closest('form').find('.title-betriebsleiter').removeClass('text-red');

  let checked = false;
  $(element).closest('form').find('#verbrauch-liste input.betriebsleiter-row').each(function(i, v) {
    if ($(v).is(':checked')) {
      checked = true;
    }
  });

  if ($(element).closest('form').find('#verbrauch-liste input.betriebsleiter-row').length > 0 && checked === false) {
    $(element).closest('form').find('.title-betriebsleiter').addClass('text-red');
  } else {
    $(element).closest('form').submit();
    setTimeout(function() {
      ajaxDialog('close');
    }, 100);
  }
};

/**
 * Verbrauchsliste Get Betriebe
 * @param element
 * @param bereich
 */
window.getBetriebe = function(element, bereich) {
  const dateFrom = $(element).closest('form').find('#verbrauchDateFrom').val();
  const dateTo = $(element).closest('form').find('#verbrauchDateTo').val();
  const dateNotEmpty = (dateFrom !== '' && dateTo !== '');

  try {
    if (dateNotEmpty) {
      const parsedDateFrom = new Date(dateFrom);
      const parsedDateTo = new Date(dateTo);

      const dateFromIsBigger = (parsedDateFrom.getTime() > parsedDateTo.getTime());
      const dateNotSameYear = (parsedDateFrom.getFullYear() !== parsedDateTo.getFullYear());

      if (!dateFromIsBigger && !dateNotSameYear) {
        $.ajax({
          url: BASE_PATH + 'ajax/helper/lager/ajax.getVerbrauchslisteBetriebe',
          type: 'post',
          data: {
            bereich: bereich,
            dateFrom: dateFrom,
          },
          success: function(html) {
            if (html) {
              $('#list_betriebe').html(html);
            }
          },
        });
      } else {
        $('#list_betriebe').html('<div class="row"><div class="col-xs-12"><article class="message message--danger"><div class="message__body">' + LANG_STRINGS.datumSelbesJahr + '</div></article></div></div>');
        $('#list_anlagen').html('');

        $('#check-anlagen').attr('disabled', 'disabled').prop('checked', false);
        $('#withReinkupfer').attr('disabled', 'disabled').prop('checked', false);
      }
    } else {
      $('#list_betriebe').html('<article class="message message--danger"><div class="message__body">' + LANG_STRINGS.datumSelbesJahr + '</div></article>');
    }
  } catch (err) {
    $('#list_betriebe').html('<article class="message message--danger"><div class="message__body">' + LANG_STRINGS.datumSelbesJahr + '</div></article>');
  }
};

/**
 * Verbrauchsliste Show Anlagen
 */
window.showAnlagen = function() {
  const bereich = 'pflanzenschutz';

  if ($('#check-anlagen').is(':checked')) {
    let factoryList = {};
    $('#list_betriebe .row').each(function(i, v) {
      if ($(v).find('input').is(':checked')) {
        factoryList[i] = $(v).find('input').val();
      }
    });

    if (factoryList) {
      $.ajax({
        url: BASE_PATH + 'ajax/helper/lager/ajax.getVerbrauchslisteAnlagen',
        type: 'post',
        data: {
          factorys: factoryList,
          bereich: bereich,
          withReinkupfer: $('#withReinkupfer').is(':checked'),
        },
        success: function(html) {
          if (html) {
            $('#list_anlagen').html(html);
          }
        },
      });
    }
  } else {
    $('#list_anlagen').html('');
  }
};

/**
 * Verbrauchsliste Enable Anlagen
 * @param obj
 */
window.enableAnlagen = function(obj) {
  let checked = false;
  $(obj).closest('form').find('#list_betriebe .row').each(function(i, v) {
    if ($(v).find('input').is(':checked')) {
      checked = true;
    }
  });

  if (checked === true) {
    $('#check-anlagen').removeAttr('disabled');
    $('#withReinkupfer').removeAttr('disabled');
  } else {
    $('#check-anlagen').attr('disabled', 'disabled');
    $('#withReinkupfer').attr('disabled', 'disabled');
  }
};

/**
 * Verbrauchsliste Select all Anlagen
 * @param element
 */
window.selectAllAnlagen = function(element) {
  const withAnlagen = $('#check-anlagen');
  if ($(element).is(':checked')) {
    withAnlagen.prop('checked', true).trigger('onchange');
    withAnlagen.attr('readonly', 'readonly').addClass('readonly');
    withAnlagen.attr('onclick', 'return false;');

    $('#perCulture option[data-empty="1"]').remove();
  } else {
    withAnlagen.prop('checked', false).trigger('onchange');
    withAnlagen.removeAttr('readonly').removeClass('readonly');
    withAnlagen.removeAttr('onclick');

    $('#perCulture').prepend('<option value="" data-empty="1">' + LANG_STRINGS.alle + '</option>');
  }
};

/**
 * Send Form Verbrauchsliste
 * @param element
 */
window.sendFormVerbrauchsliste = function(element) {
  const dateFrom = $(element).closest('form').find('#verbrauchDateFrom');
  dateFrom.closest('div.form-field').removeClass('form-field--error');

  const dateTo = $(element).closest('form').find('#verbrauchDateTo');
  dateTo.closest('div.form-field').removeClass('form-field--error');

  $(element).closest('form').find('.title-betriebe').removeClass('text-red');

  if ($(element).hasClass('excel')) {
    $('#pdf').remove();
  } else if ($(element).hasClass('pdf')) {
    $('#excel').remove();
  }

  let checked = false;
  $(element).closest('form').find('#list_betriebe').each(function(i, v) {
    if ($(v).find('input').is(':checked')) {
      checked = true;
    }
  });

  const parsedDateFrom = new Date(dateFrom.val());
  const parsedDateTo = new Date(dateTo.val());

  if (dateFrom.val() === '' || dateTo.val() === '' || checked === false) {
    if (dateFrom.val() === '') {
      $(element).closest('form').find('#verbrauchDateFrom').closest('div.form-field').addClass('form-field--error');
    }
    if (dateTo.val() === '') {
      $(element).closest('form').find('#verbrauchDateTo').closest('div.form-field').addClass('form-field--error');
    }
    if (checked === false) {
      $(element).closest('form').find('.title-betriebe').addClass('text-red');
    }
  } else if (parsedDateFrom.getTime() > parsedDateTo.getTime()) {
    $(element).closest('form').find('#verbrauchDateFrom').closest('div.form-field').addClass('form-field--error');
    $(element).closest('form').find('#verbrauchDateTo').closest('div.form-field').addClass('form-field--error');
  } else if (parsedDateFrom.getFullYear() !== parsedDateTo.getFullYear()) {
    $(element).closest('form').find('#verbrauchDateFrom').closest('div.form-field').addClass('form-field--error');
    $(element).closest('form').find('#verbrauchDateTo').closest('div.form-field').addClass('form-field--error');
  } else {
    $(element).closest('form').submit();

    setTimeout(function() {
      ajaxDialog('close');
    }, 100);
  }
};